module.exports = __webpack_public_path__ + "img/modular03_active.0b554e51.png";